<template>
    <div>

        <el-card>

            <el-table :data="tableData" border v-loading='loading'>

                <el-table-column type="index" width="50"></el-table-column>

                <el-table-column label="用户名" prop="internalUserid"></el-table-column>

                <el-table-column label="真实姓名" prop="name"></el-table-column>

            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.pageIndex"
                           :page-sizes="[10,20]"
                           :page-size="form.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>

        </el-card>

    </div>
</template>

<script>
import services from '../serve.services'

export default {
    props: {
        id: Number
    },
    data() {
        return {
            loading: true,
            tableData: [],
            form:{
                // keyword:"",
                pageSize:10,
                pageIndex:1,
            },
            total:null,
        }
    },
    mounted() {

        this.request()
    },
    methods: {
        request() { // 请求数据
            let params={
                ...this.form,
                groupId:this.id
            }
            services.groupUser(params)
                .then(res => {
                    this.tableData = res.list
                    this.total=res.total
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },
        handleSizeChange(val){
            let pages = Math.ceil(this.total / val);
            this.form.pageSize = val;
            if(this.form.pageIndex > pages ){
                this.form.pageIndex  = 1;
            };
            this.request()
        },
        handleCurrentChange(val){
            this.form.pageIndex = val;
            this.request();
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
